import { render, staticRenderFns } from "./customerBusinessStatisticsDetail.vue?vue&type=template&id=7cd7b4a1&scoped=true"
import script from "./customerBusinessStatisticsDetail.vue?vue&type=script&lang=js"
export * from "./customerBusinessStatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./customerBusinessStatisticsDetail.vue?vue&type=style&index=0&id=7cd7b4a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd7b4a1",
  null
  
)

export default component.exports